// removed by extract-text-webpack-plugin
module.exports = {"tag-container":"tag-container__1qBKJ","tag":"tag__2Zu3n","cross-button":"cross-button__ncBFD"};


//////////////////
// WEBPACK FOOTER
// ./styles/reactTagInput.scss
// module id = 1277
// module chunks = 68